<template>
  <div>
    <Index v-if="show === 'index'" :xmlAuthenticators="xmlAuthenticators" :meta="meta" :infoTotalModels="infoTotalModels"
           @editXmlAuthenticator="editXmlAuthenticator($event)"
           @deleteXmlAuthenticator="deleteXmlAuthenticator($event)"
           @newXmlAuthenticator="newXmlAuthenticator()"
           @pagination="pagination($event)"
           @findGeneric="findGeneric($event)"/>

    <Form v-else :xmlAuthenticator="currentXmlAuthenticator"
          @save="save($event)"
          @cancel="show = 'index'"
          @deleteXmlAuthenticator="deleteXmlAuthenticator($event)"
          @saveAndClose="save($event, true)"/>
  </div>

</template>

<script>
  import Index from '@/components/definitions/integrations/xmlAuthenticator/Index'
  import Form from '@/components/definitions/integrations/xmlAuthenticator/Form'
  import ModelMapper from '@/mixins/ModelMapper'

  export default {
    components: { Form, Index },
    computed: {
      xmlAuthenticators() {
        return this.getModels || []
      }
    },
    created() {
      this.methods = ['company_ids']
      this.order.name = 'asc'
      this.find()
    },
    data() {
      return {
        currentXmlAuthenticator: {},
        modelPathPrefix: 'integrations',
        nameModel: 'XmlAuthenticator',
        show: 'index'
      }
    },
    methods: {
      deleteXmlAuthenticator(model) {
        if (!(confirm('Tem certeza?')))
          return

        this.asyncTemplateDelete(model, {
          after: () => {
            if (this.show === 'index')
              this.find()
            else
              this.show = 'index'
          }
        })
      },
      editXmlAuthenticator(model) {
        this.currentXmlAuthenticator = model
        this.show = 'show'
      },
      find() {
        this.asyncTemplateSelect()
      },
      findGeneric(generic) {
        this.query.generic = generic
        this.find()
      },
      newXmlAuthenticator() {
        this.currentXmlAuthenticator = {}
        this.show = 'show'
      },
      save(model, close) {
        this.asyncTemplateSave(model, {
          after: ({model}) => {
            this.currentXmlAuthenticator = model
            this.$notify.add('Salvo com sucesso!')

            if (close)
              this.show = 'index'
          }
        })
      }
    },
    mixins: [ModelMapper],
    name: 'XmlAuthenticator',
    watch: {
      show(newValue, oldValue) {
        if (newValue === 'index' && oldValue === 'show')
          this.find()
      }
    }
  }
</script>

<style scoped>

</style>